<template>
  <div class="resume">
    <div class="banner"></div>

    <div :class="this.isMobile.value ? 'profile-mobile' : 'profile'">
      <div class="profile-header">
        <div class="profile-header__title">
          <h2>新闻详情</h2>
        </div>
      </div>

      <div class="resumeForm">
        <el-form ref="form" :model="form">
          <div class="wrap">
            <div class="title-box">
              <div class="detail-title">{{form.title}}</div>
              <div class="sub-title-box">
                <div>类型：{{getDict(typeOptions,'dictValue', 'dictLabel', form.type)}}</div>
                <div v-if="form.createTime">发布日期：{{form.createTime.split(' ')[0]}}</div>
              </div>
            </div>
            <el-divider></el-divider>
            <!-- <p v-html="form.content"></p> -->
            <div class="ql-container ql-snow">
              <div class="ql-editor" v-html="form.content"></div>
            </div>
          </div>
<!--          <el-form-item label="类型" prop="type">-->
<!--            <el-select v-model="form.type" placeholder="请选择类型" disabled>-->
<!--              <el-option-->
<!--                v-for="dict in typeOptions"-->
<!--                :key="dict.dictValue"-->
<!--                :label="dict.dictLabel"-->
<!--                :value="parseInt(dict.dictValue)"-->
<!--              ></el-option>-->
<!--            </el-select>-->
<!--          </el-form-item>-->
<!--          <el-form-item label="标题" prop="title">-->
<!--            <el-input v-model="form.title" placeholder="请输入标题" disabled/>-->
<!--          </el-form-item>-->
<!--&lt;!&ndash;          <el-form-item label="内容">&ndash;&gt;-->
<!--&lt;!&ndash;            <el-input type="textarea" v-model="form.content" :autosize="{ minRows: 3, maxRows: 15}" disabled/>&ndash;&gt;-->
<!--&lt;!&ndash;          </el-form-item>&ndash;&gt;-->
<!--          <el-form-item label="招募内容">-->
<!--            <div class="ql-editor" v-html="form.content"></div>-->
<!--          </el-form-item>-->
<!--          <el-form-item label="创建日期" prop="createTime">-->
<!--            <el-date-picker clearable size="small" style="width: 100%"-->
<!--                            v-model="form.createTime"-->
<!--                            type="date"-->
<!--                            value-format="yyyy-MM-dd"-->
<!--                            disabled-->
<!--                            placeholder="选择创建日期">-->
<!--            </el-date-picker>-->
<!--          </el-form-item>-->
          <el-form-item label="附件" prop="bidFileList">
            <el-upload
              ref="fileUpload"
              :limit="10"
              accept="doc,docx,xls,xlsx,ppt,zip,rar,pdf,jpg,png,jpeg"
              multiple
              :on-exceed="fileLimitCallback"
              :action="upload.url"
              :headers="upload.headers"
              :file-list="bidFileList"
              :on-progress="handleFileUploadProgress"
              :before-upload="onBeforeUpload"
              :on-change="handleFileChange"
              :on-success="
                  (response, file, fileList) =>
                    uploadFileSuccess(response, file, fileList)
                "
              :on-error="handleFileError"
              :on-preview="handlePreview"
              :on-remove="
                  (file, fileList) => removeFileSuccess(file, fileList)
                "
              :auto-upload="false"
              disabled
            >
            </el-upload>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button type="primary"><router-link to="/">返回</router-link></el-button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { listPurchaseNews, getPurchaseNews } from "@/api/purchase/purchaseNews";
import {getDicts} from "@/utils/data";
import { getToken } from "@/utils/auth";
import Editor from '@/components/Editor';
let positionY = 0;

export default {
  name: "news",
  components: {
    Editor,
  },
  data() {
    return {
      currentPage: 1,
      jobCategories: [],
      jobCities: [],
      location_code_list: [],
      cityList: [],
      cities: [],
      results: [],
      searchBarFixedTop: false,
      loading: false,
      // 弹出层标题
      title: "",
      // 是否显示弹出层
      open: false,
      // 状态字典
      statusOptions: [],
      // 表单参数
      form: {},
      upload: {
        // 是否禁用上传
        isUploading: false,
        // 设置上传的请求头部
        headers: { Authorization: "Bearer " + getToken() },
        // 上传的地址
        url: process.env.VUE_APP_BASE_API + "/api/purchase/file/upload",
        // 上传的文件列表
        fileList: [],
      },
      bidFileList: [],
      disabled: false,
      // 总条数
      total: 0,
      // 查询参数
      queryParams: {
        // pageNum: 1,
        // pageSize: 10,
      },
      // 显示搜索条件
      showSearch: true,
      typeOptions: [],
      detailInfo:{
        html:"<div> \n" +
                "\t\t<p class=\"detail_text\"> \n" +
                "\t\t\t</p><p style=\"text-autospace:ideograph-numeric;text-align:center;line-height:47px\"><a></a><strong><span style=\";font-family:宋体;font-size:21px\"><span style=\"font-family:宋体\">中国铁建</span><span style=\"font-family:Calibri\">11</span><span style=\"font-family:宋体\">局西十高铁湖北段</span><span style=\"font-family:Calibri\">XSZQ-1</span><span style=\"font-family:宋体\">标项目（钢材）竞争性谈判采购</span></span></strong></p><p style=\"text-autospace:ideograph-numeric;text-align:center;line-height:47px\"><strong><span style=\";font-family:宋体;font-size:21px\"><span style=\"font-family:宋体\">结果公示</span></span></strong></p><p style=\"text-align:center;line-height:150%\"><span style=\";font-family:宋体;line-height:150%;font-size:16px\"><span style=\"font-family:宋体\">采购</span></span><span style=\";font-family:宋体;line-height:150%;font-size:16px\"><span style=\"font-family:宋体\">编号：</span>CRCC-</span><span style=\";font-family:宋体;line-height:150%;font-size:16px\"><span style=\"font-family:宋体\">WH</span></span><span style=\";font-family:宋体;line-height:150%;font-size:16px\"><span style=\"font-family:宋体\">JC-</span></span><span style=\";font-family:宋体;line-height:150%;font-size:16px\"><span style=\"font-family:宋体\">2021-73-3</span></span></p><p style=\"text-indent:32px;text-autospace:ideograph-numeric;text-align:justify;text-justify:inter-ideograph;line-height:33px\"><span style=\";font-family:宋体;color:rgb(81,81,81);font-size:16px\"><span style=\"font-family:宋体\">各报价人：</span></span></p><p style=\"text-indent:32px;text-autospace:ideograph-numeric;text-align:justify;text-justify:inter-ideograph;line-height:33px\"><span style=\";font-family:宋体;color:rgb(81,81,81);font-size:16px\"><span style=\"font-family:宋体\">中国铁建</span>11局西十高铁湖北段XSZQ-1标项目（钢材）竞争性谈判采购,采购编号：CRCC-WHJC-2021-73-3,已于2021年12月29日上午10时整在湖北省武汉市武昌区丁字桥路25号中铁物资中南大厦8楼武汉中心评标室进行了竞争谈判，评标委员会根据相关法律、法规的规定和采购文件载明的评审办法完成了谈判工作，现将谈判结果公示如下：</span></p><p style=\"text-align:center;line-height:150%\"><strong><span style=\";font-family:宋体;line-height:150%;font-size:16px\"><span style=\"font-family:宋体\">一、</span> </span></strong><strong><span style=\";font-family:宋体;line-height:150%;font-size:16px\"><span style=\"font-family:宋体\">采购</span></span></strong><strong><span style=\";font-family:宋体;line-height:150%;font-size:16px\"><span style=\"font-family:宋体\">公告发布日期及媒体</span></span></strong></p><p style=\"line-height:150%\"><span style=\";font-family:宋体;line-height:150%;font-size:16px\"><span style=\"font-family:宋体\">采购</span></span><span style=\";font-family:宋体;line-height:150%;font-size:16px\"><span style=\"font-family:宋体\">公告发布日期：</span></span><span style=\"text-decoration:underline;\"><span style=\"font-family: 宋体;line-height: 150%;font-size: 16px\"><span style=\"font-family:宋体\">20</span></span></span><span style=\"text-decoration:underline;\"><span style=\"font-family: 宋体;line-height: 150%;font-size: 16px\"><span style=\"font-family:宋体\">21</span></span></span><span style=\";font-family:宋体;line-height:150%;font-size:16px\"><span style=\"font-family:宋体\">年</span></span><span style=\"text-decoration:underline;\"><span style=\"font-family: 宋体;line-height: 150%;font-size: 16px\"><span style=\"font-family:宋体\">12</span></span></span><span style=\";font-family:宋体;line-height:150%;font-size:16px\"><span style=\"font-family:宋体\">月</span></span><span style=\"text-decoration:underline;\"><span style=\"font-family: 宋体;line-height: 150%;font-size: 16px\"><span style=\"font-family:宋体\">20</span></span></span><span style=\";font-family:宋体;line-height:150%;font-size:16px\"><span style=\"font-family:宋体\">日；</span></span></p><p style=\"line-height:150%\"><span style=\";font-family:宋体;line-height:150%;font-size:16px\"><span style=\"font-family:宋体\">采购</span></span><span style=\";font-family:宋体;line-height:150%;font-size:16px\"><span style=\"font-family:宋体\">公告发布媒体：本次</span></span><span style=\";font-family:宋体;line-height:150%;font-size:16px\"><span style=\"font-family:宋体\">采购</span></span><span style=\";font-family:宋体;line-height:150%;font-size:16px\"><span style=\"font-family:宋体\">公告在中国采购与招标网（</span>http://www.chinabidding.com.cn/）、中国铁建物资采购网（http://ecm.crcc.cn/）</span><span style=\";font-family:宋体;line-height:150%;font-size:16px\"><span style=\"font-family:宋体\">、中国大宗物资网</span>(http://www.zgdzwz.com)</span><span style=\";font-family:宋体;line-height:150%;font-size:16px\"><span style=\"font-family:宋体\">上同时发布。</span></span></p><p style=\"text-align:center;line-height:150%\"><strong><span style=\";font-family:宋体;line-height:150%;font-size:16px\"><span style=\"font-family:宋体\">二、</span> 推荐成交供应商候选人信息</span></strong></p><table border=\"1\" width=\"576\"><tbody><tr style=\"height:28px\" class=\"firstRow\"><td width=\"83\" valign=\"center\" style=\"padding: 0px 7px; border-width: 1px; border-style: solid; border-color: windowtext;\"><p style=\";line-height:20px\"><strong><span style=\"font-family: 宋体;font-size: 16px\"><span style=\"font-family:宋体\">物资名称</span></span></strong></p></td><td width=\"66\" valign=\"center\" style=\"padding: 0px 7px; border-width: 1px; border-style: solid; border-color: windowtext;\"><p style=\";text-align:center;line-height:20px\"><strong><span style=\"font-family: 宋体;font-size: 16px\"><span style=\"font-family:宋体\">包件号</span></span></strong></p></td><td width=\"233\" valign=\"center\" style=\"padding: 0px 7px; border-width: 1px; border-style: solid; border-color: windowtext;\"><p style=\";text-align:center;line-height:20px\"><strong><span style=\"font-family: 宋体;font-size: 16px\"><span style=\"font-family:宋体\">成交供应商候选人</span></span></strong></p></td><td width=\"128\" valign=\"top\" style=\"padding: 1px; border-width: 1px; border-style: solid; border-color: windowtext; background: rgb(250, 250, 250);\"><p style=\";text-align:center;line-height:20px\"><strong><span style=\"font-family: 宋体;font-size: 16px\"><span style=\"font-family:宋体\">拟中标价</span></span></strong></p></td><td width=\"66\" valign=\"center\" style=\"padding: 0px; border-width: 1px; border-style: solid; border-color: windowtext;\"><p style=\";text-align:center;line-height:20px\"><strong><span style=\"font-family: 宋体;font-size: 16px\"><span style=\"font-family:宋体\">排序</span></span></strong></p></td></tr><tr style=\"height:28px\"><td width=\"83\" valign=\"center\" rowspan=\"3\" style=\"padding: 0px 7px; border-left: 1px solid windowtext; border-right: 1px solid windowtext; border-top: none; border-bottom: 1px solid windowtext;\"><p style=\"text-align:center\"><span style=\"font-family: 宋体;font-size: 16px\"><span style=\"font-family:宋体\">钢材</span></span></p></td><td width=\"66\" valign=\"center\" rowspan=\"3\" style=\"padding: 0px 7px; border-left: 1px solid windowtext; border-right: 1px solid windowtext; border-top: none; border-bottom: 1px solid windowtext;\"><p style=\"text-align:center\"><span style=\"font-family:宋体;font-size:14px\"><span style=\"font-family:宋体\">GC-01</span></span></p></td><td width=\"233\" valign=\"center\" style=\"padding: 0px 7px; border-left: none; border-right: 1px solid windowtext; border-top: none; border-bottom: 1px solid windowtext;\"><p style=\";text-align:center;vertical-align:middle\"><span style=\"font-family: 宋体;font-size: 13px\"><span style=\"font-family:宋体\">湖北金捷源商贸有限公司</span></span></p></td><td width=\"128\" valign=\"center\" style=\"padding: 1px; border-left: none; border-right: 1px solid windowtext; border-top: none; border-bottom: 1px solid windowtext; background: rgb(250, 250, 250);\"><p style=\";text-align:center;vertical-align:middle\"><strong><span style=\"font-family: 宋体;font-size: 13px\"><span style=\"font-family:宋体\">67,434,700.00</span></span></strong></p></td><td width=\"66\" valign=\"center\" style=\"padding: 0px; border-left: none; border-right: 1px solid windowtext; border-top: none; border-bottom: 1px solid windowtext;\"><p style=\"text-align:center\"><span style=\"font-family: 宋体;font-size: 16px\"><span style=\"font-family:宋体\">1</span></span></p></td></tr><tr style=\"height:28px\"><td width=\"233\" valign=\"center\" style=\"padding: 0px 7px; border-left: none; border-right: 1px solid windowtext; border-top: none; border-bottom: 1px solid windowtext;\"><p style=\";text-align:center;vertical-align:middle\"><span style=\"font-family: 宋体;font-size: 13px\"><span style=\"font-family:宋体\">武汉鑫和茂物资有限公司</span></span></p></td><td width=\"128\" valign=\"center\" style=\"padding: 1px; border-left: none; border-right: 1px solid windowtext; border-top: none; border-bottom: 1px solid windowtext; background: rgb(250, 250, 250);\"><p style=\";text-align:center;vertical-align:middle\"><strong><span style=\"font-family: 宋体;font-size: 13px\"><span style=\"font-family:宋体\">69,394,700.00</span></span></strong></p></td><td width=\"66\" valign=\"center\" style=\"padding: 0px; border-left: none; border-right: 1px solid windowtext; border-top: none; border-bottom: 1px solid windowtext;\"><p style=\"text-align:center\"><span style=\"font-family: 宋体;font-size: 16px\"><span style=\"font-family:宋体\">2</span></span></p></td></tr><tr style=\"height:28px\"><td width=\"233\" valign=\"center\" style=\"padding: 0px 7px; border-left: none; border-right: 1px solid windowtext; border-top: none; border-bottom: 1px solid windowtext;\"><p style=\";text-align:center;vertical-align:middle\"><span style=\"font-family: 宋体;font-size: 13px\"><span style=\"font-family:宋体\">北京甘电科技有限公司</span></span></p></td><td width=\"128\" valign=\"center\" style=\"padding: 1px; border-left: none; border-right: 1px solid windowtext; border-top: none; border-bottom: 1px solid windowtext; background: rgb(250, 250, 250);\"><p style=\";text-align:center;vertical-align:middle\"><strong><span style=\"font-family: 宋体;font-size: 13px\"><span style=\"font-family:宋体\">70,910,300.00</span></span></strong></p></td><td width=\"66\" valign=\"center\" style=\"padding: 0px; border-left: none; border-right: 1px solid windowtext; border-top: none; border-bottom: 1px solid windowtext;\"><p style=\"text-align:center\"><span style=\"font-family: 宋体;font-size: 16px\"><span style=\"font-family:宋体\">3</span></span></p></td></tr></tbody></table><p style=\"text-indent:32px;line-height:150%\"><span style=\";font-family:宋体;line-height:150%;font-size:16px\"><span style=\"font-family:宋体\">公示期</span></span><span style=\"text-decoration:underline;\"><span style=\"font-family: 宋体;line-height: 150%;font-size: 16px\"><span style=\"font-family:宋体\">3</span></span></span><span style=\";font-family:宋体;line-height:150%;font-size:16px\"><span style=\"font-family:宋体\">日，自</span></span><span style=\"text-decoration:underline;\"><span style=\"font-family: 宋体;line-height: 150%;font-size: 16px\"><span style=\"font-family:宋体\">202</span></span></span><span style=\"text-decoration:underline;\"><span style=\"font-family: 宋体;line-height: 150%;font-size: 16px\"><span style=\"font-family:宋体\">1</span></span></span><span style=\";font-family:宋体;line-height:150%;font-size:16px\"><span style=\"font-family:宋体\">年</span></span><span style=\"text-decoration:underline;\"><span style=\"font-family: 宋体;line-height: 150%;font-size: 16px\"><span style=\"font-family:宋体\">12</span></span></span><span style=\";font-family:宋体;line-height:150%;font-size:16px\"><span style=\"font-family:宋体\">月</span></span><span style=\"text-decoration:underline;\"><span style=\"font-family: 宋体;line-height: 150%;font-size: 16px\"><span style=\"font-family:宋体\">30</span></span></span><span style=\";font-family:宋体;line-height:150%;font-size:16px\"><span style=\"font-family:宋体\">日至</span></span><span style=\"text-decoration:underline;\"><span style=\"font-family: 宋体;line-height: 150%;font-size: 16px\"><span style=\"font-family:宋体\">202</span></span></span><span style=\"text-decoration:underline;\"><span style=\"font-family: 宋体;line-height: 150%;font-size: 16px\"><span style=\"font-family:宋体\">2</span></span></span><span style=\";font-family:宋体;line-height:150%;font-size:16px\"><span style=\"font-family:宋体\">年</span></span><span style=\"text-decoration:underline;\"><span style=\"font-family: 宋体;line-height: 150%;font-size: 16px\"><span style=\"font-family:宋体\">01</span></span></span><span style=\";font-family:宋体;line-height:150%;font-size:16px\"><span style=\"font-family:宋体\">月</span></span><span style=\"text-decoration:underline;\"><span style=\"font-family: 宋体;line-height: 150%;font-size: 16px\"><span style=\"font-family:宋体\">01</span></span></span><span style=\";font-family:宋体;line-height:150%;font-size:16px\"><span style=\"font-family:宋体\">日。公示期间，报价人和其他利害关系人如对公示的评标结果有异议，可向采购人或监督部门举报。举报人是法人的，必须由其法定代表人或者授权代表签字并盖章；其他组织或者个人举报的，必须由其主要负责人或者本人签字并附有效身份证明复印件。举报人如实反映情况受法律保护。公示期满，如无异议，即时生效。</span> </span></p><p style=\"text-indent:32px;line-height:150%\"><span style=\";font-family:宋体;line-height:150%;font-size:16px\"><span style=\"font-family:宋体\">特此公告！</span></span></p><p style=\"text-indent:28px;text-autospace:ideograph-numeric;line-height:29px\"><span style=\"font-family: 宋体;font-size: 16px\">&nbsp;</span></p><p style=\"text-indent:32px;line-height:150%\"><span style=\"font-family: 宋体;line-height: 150%;font-size: 16px\"><span style=\"font-family:宋体\">采</span> 购 人：中铁十一局集团第四工程有限公司西十高铁湖北段XSZQ-1标项目经理部一分部</span></p><p style=\"text-indent:32px;line-height:150%\"><span style=\"font-family: 宋体;line-height: 150%;font-size: 16px\"><span style=\"font-family:宋体\">详细地址：湖北省十堰市郧阳区十堰大道盛泓集中充电站院内</span></span></p><p style=\"text-indent:32px;line-height:150%\"><span style=\"font-family: 宋体;line-height: 150%;font-size: 16px\"><span style=\"font-family:宋体\">联</span> 系 人：梁艳斌</span></p><p style=\"text-indent:32px;line-height:150%\"><span style=\"font-family: 宋体;line-height: 150%;font-size: 16px\"><span style=\"font-family:宋体\">电</span> &nbsp;&nbsp;&nbsp;话：18694062277</span></p><p style=\"text-indent:32px;line-height:150%\"><span style=\"font-family: 宋体;line-height: 150%;font-size: 16px\"><span style=\"font-family:宋体\">邮</span> &nbsp;&nbsp;&nbsp;箱：</span><a href=\"mailto:502160096@qq.com\"><span style=\";font-family:宋体;line-height:150%;color:rgb(0,0,0);font-size:16px\"><span style=\"font-family:宋体\">502160096@qq.com</span></span></a></p><p style=\"text-indent:32px;line-height:150%\"><span style=\"font-family: 宋体;line-height: 150%;font-size: 16px\">&nbsp;</span></p><p style=\"text-indent:32px;line-height:150%\"><span style=\"font-family: 宋体;line-height: 150%;font-size: 16px\"><span style=\"font-family:宋体\">采购组织机构：中国铁建股份有限公司物资集中采购武汉中心</span> </span></p><p style=\"text-indent:32px;line-height:150%\"><span style=\"font-family: 宋体;line-height: 150%;font-size: 16px\"><span style=\"font-family:宋体\">地址：湖北省武汉市武昌区丁字桥路</span>25号办公楼8楼 &nbsp;</span></p><p style=\"text-indent:32px;line-height:150%\"><span style=\"font-family: 宋体;line-height: 150%;font-size: 16px\"><span style=\"font-family:宋体\">联系人及电话：</span> </span></p><p style=\"text-indent:32px;line-height:150%\"><span style=\"font-family: 宋体;line-height: 150%;font-size: 16px\"><span style=\"font-family:宋体\">王</span> 磊（采购文件答疑联系人）13971676935</span></p><p style=\"text-indent:32px;line-height:150%\"><span style=\"font-family: 宋体;line-height: 150%;font-size: 16px\"><span style=\"font-family:宋体\">关星星（发票开具、保证金退款联系人</span></span><span style=\"font-family: 宋体;line-height: 150%;font-size: 16px\"><span style=\"font-family:宋体\">）</span></span><span style=\"font-family: 宋体;line-height: 150%;font-size: 16px\"><span style=\"font-family:宋体\">13986099543</span></span></p><p style=\"text-indent:32px;line-height:150%\"><span style=\"font-family: 宋体;line-height: 150%;font-size: 16px\"><span style=\"font-family:宋体\">监督电话：</span>010-51881390</span></p><p style=\"text-align:right\"><span style=\"font-family: 宋体;font-size: 16px\"><span style=\"font-family:宋体\">2021年12月29日</span></span></p><p><br></p>\n" +
                "\t\t<p></p>\n" +
                "\t\t\n" +
                "\t</div>"
      }
    };
  },

  created() {

    getDicts("purchase_news_type").then(response => {
      this.typeOptions = response.data;
    });

    this.handleUpdate(this.$route.query.id);

  },
  mounted() {
  },
  computed: {
    queryFilter() {
      return {
        // postName: this.searchKeyword,
      };
    },
    clearable() {
      return (
        this.job_category_id_list.length !== 0 ||
        this.location_code_list.length !== 0
      );
    }
  },
  watch: {
    // queryFilter: function(newVal, oldVal) {
    //   this.searchBarFixedTop && window.scrollTo(0, positionY);
    //   this.fetchList();
    // }
  },
  methods: {
    typeFormat(row, column) {
      let list = this.typeOptions.filter(i=>i.dictValue == row.type);
      if(list.length > 0){
        return list[0].dictLabel;
      }
      return '';
    },
    handleQuery() {
      // this.queryParams.pageNum = 1;
      this.getList();
    },
    getList() {
      this.loading = true;
      listPurchaseNews(this.queryParams).then(response => {
        this.results = response;
        this.total = response.total;
        this.loading = false;
      });
    },
    fetchList() {
      this.loading = true;

      return this.request
        .get("/api/purchase/purchaseNews/list", this.queryFilter)
        .then(response => {
          this.results = response;
          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
        });
    },
    // 状态字典翻译
    statusFormat(row, column) {
      let list = this.statusOptions.filter(i=>i.dictValue == row.status);
      if(list.length > 0){
        return list[0].dictLabel;
      }
      return '';
    },
    // 取消按钮
    cancel() {
      this.open = false;
      this.reset();
    },
    // 表单重置
    reset() {
      this.form = {
        id: null,
        content: null,
        createBy: null,
        createTime: null,
        updateBy: null,
        updateTime: null,
        version: null,
        uuid: null,
      };
      this.bidFileList = [];
    },
    /** 修改按钮操作 */
    handleUpdate(id) {
      this.reset();
      getPurchaseNews(id).then(response => {
        this.form = response.data;
        this.bidFileList = response.data.bidFileList;
      });
    },

    // 文件超出个数限制时的钩子函数
    fileLimitCallback(files, fileList) {
      this.$message.warning(`当前限制最多选择 10 个文件`);
    },
    onBeforeUpload(file) {
      const isLt200M = file.size / 1024 / 1024 < 20;
      if (!isLt200M) {
        this.$message.error("上传文件大小不能超过 20M!");
        return false;
      }
      return true;
    },
    handleFileChange(file, fileList) {
    },
    // 文件上传中处理
    handleFileUploadProgress(event, file, fileList) {
      this.upload.isUploading = true;
    },
    // 文件超出个数限制时的钩子函数
    importExcelLimitCallbck() {
      this.$message.warning(`当前限制最多导入 1 个文件`);
    },
    // 处理附件上传
    uploadFileSuccess(response, file, fileList) {
      this.upload.isUploading = false;
      if (response != null && response.code == 200) {
        let files = [];
        fileList.forEach(function (val, index) {
          if(val.response){
            files.push(val.response.data);
          }else {
            files.push(val);
          }

        });
        this.bidFileList = files;
        this.$message.success("上传成功");
      } else {
        this.$message.error(response.msg);
      }
    },
    // 文件上传失败处理
    handleFileError(err, file, fileList) {
      this.upload.isUploading = false;
      this.$message.error("文件上传失败");
    },
    // 处理附件移除
    removeFileSuccess(file, fileList) {
      this.bidFileList = fileList;
    },
    // 文件提交处理
    submitUpload() {
      this.$refs.fileUpload.submit();
    },
    // 文件预览
    handlePreview(file) {
      window.open(file.url);
    },
    // 获取字典值
    getDict(dictArr, key, label, val){
      console.log("getDict: ", dictArr, key, label, val);
      for (const item of dictArr) {
        if(item[key] == val){
          return item[label]
        }
      }
      return ""
    }
  }
};
</script>
<style lang="less" scoped>
.banner {
  background-image: url("//sf1-ttcdn-tos.pstatp.com/obj/ttfe/ATSX/my_resume_banner_1577084307030.jpg");
  background-size: 100% 100%;
  height: 300px;
  background-repeat: no-repeat;
}

.profile {
  width: 1000px;
  margin: auto;
  margin-top: -200px;
  &-header {
    color: #fff;
    display: flex;
    justify-content: space-between;

    align-items: center;
  }

  .resumeForm {
    margin-top: 30px;
    background: #fff;
    box-shadow: 0px 9px 20px 0px #c2c1c180;
    border-radius: 4px;
    padding: 30px;

    .resumeViewSection {
      min-height: 200px;
      margin-bottom: 30px;
      &__title {
        margin-bottom: 20px;
      }
      .resumeViewForm {
        margin-bottom: 30px;
      }
      .resumeViewItem {
        float: left;
        width: 50%;
        margin-bottom: 20px;
        min-height: 50px;
        &__resumeAttachment {
          display: flex;
          padding: 10px;
          background-color: @bg-base-color;
          align-items: center;
          time {
            color: @regular-text-color;
            font-size: @font-size-base;
          }
          .fileIcon {
            margin-right: 10px;
            width: 50px;
            height: 50px;
          }
          .download-link {
            margin-left: auto;

            .el-icon-download {
              font-size: @font-size-large;
              border-radius: 50%;
              border: 1px solid @border-base-color;
              padding: 4px;
            }
            &:hover {
              color: @main-color;
            }
          }
        }
        &__content.is-link {
          color: @main-color;
          cursor: pointer;
        }
        &__label {
          color: @secondary-text-color;
          font-size: @font-size-base;
          margin-bottom: 7px;
        }
        &__content-link {
          color: @main-color;
        }
        &-desc {
          overflow: hidden;
          width: 70%;
          white-space: pre-line;
        }
      }
    }
  }
}

.profile-mobile {
  margin: auto;
  margin-top: -200px;
  &-header {
    color: #fff;
    display: flex;
    justify-content: space-between;

    align-items: center;
  }

  .resumeForm {
    margin-top: 30px;
    background: #fff;
    box-shadow: 0px 9px 20px 0px #c2c1c180;
    border-radius: 4px;
    padding: 5px;

    .resumeViewSection {
      min-height: 200px;
      margin-bottom: 30px;
      &__title {
        margin-bottom: 20px;
      }
      .resumeViewForm {
        margin-bottom: 30px;
      }
      .resumeViewItem {
        float: left;
        width: 50%;
        margin-bottom: 20px;
        min-height: 50px;
        &__resumeAttachment {
          display: flex;
          padding: 10px;
          background-color: @bg-base-color;
          align-items: center;
          time {
            color: @regular-text-color;
            font-size: @font-size-base;
          }
          .fileIcon {
            margin-right: 10px;
            width: 50px;
            height: 50px;
          }
          .download-link {
            margin-left: auto;

            .el-icon-download {
              font-size: @font-size-large;
              border-radius: 50%;
              border: 1px solid @border-base-color;
              padding: 4px;
            }
            &:hover {
              color: @main-color;
            }
          }
        }
        &__content.is-link {
          color: @main-color;
          cursor: pointer;
        }
        &__label {
          color: @secondary-text-color;
          font-size: @font-size-base;
          margin-bottom: 7px;
        }
        &__content-link {
          color: @main-color;
        }
        &-desc {
          overflow: hidden;
          width: 70%;
          white-space: pre-line;
        }
      }
    }
  }
}
.wrap{
  width: 100%;
  margin: 0 auto;
}
.title-box{
  width: 100%;
  text-align: center;
  .detail-title{
    font-size: 24px;
    margin-bottom: 30px;
  }
  .sub-title-box{
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    justify-content: center;
    font-size: 18px;
    div{
      margin-right: 30px;
    }
  }
}
@media(max-width:960px){
  .banner{
    height: 210px;
  }
  .profile-header{
    margin-left: 20px !important;
  }
}
</style>
